var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle64DError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 66 48",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M29.307 3.274A2.5 2.5 0 0 0 26.817 1h-5.434a2.5 2.5 0 0 0-2.49 2.274l-.545 6A2.5 2.5 0 0 0 20.838 12h6.524a2.5 2.5 0 0 0 2.49-2.726l-.545-6Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M27.361 2c.687 0 1.314.388 1.622 1.002l.222.445a1 1 0 0 0 1.79-.894l-.224-.446A3.812 3.812 0 0 0 27.361 0h-6.523a3.812 3.812 0 0 0-3.41 2.107l-.223.446a1 1 0 1 0 1.79.894l.222-.445A1.812 1.812 0 0 1 20.837 2h6.524Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M49.307 3.274A2.5 2.5 0 0 0 46.817 1h-5.434a2.5 2.5 0 0 0-2.49 2.274l-.545 6A2.5 2.5 0 0 0 40.838 12h6.524a2.5 2.5 0 0 0 2.49-2.726l-.545-6Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M47.361 2c.687 0 1.315.388 1.622 1.002l.222.445a1 1 0 0 0 1.79-.894l-.224-.446A3.812 3.812 0 0 0 47.361 0h-6.523a3.812 3.812 0 0 0-3.41 2.107l-.223.446a1 1 0 1 0 1.79.894l.222-.445A1.812 1.812 0 0 1 40.837 2h6.524Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M15.102 31.5a2.5 2.5 0 0 0 2.5 2.5h31a2.5 2.5 0 0 0 2.5-2.5v-15a2.5 2.5 0 0 0-2.5-2.5h-31a2.5 2.5 0 0 0-2.5 2.5v15Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M2.1 44.5V10l7.251-.725a2.5 2.5 0 0 1 2.75 2.487L12.1 34.5a2.5 2.5 0 0 0 2.5 2.5h32.922A2.5 2.5 0 0 1 50 39.834l-.97 7.164L4.6 47a2.5 2.5 0 0 1-2.5-2.5Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M2.1 8a1 1 0 0 0-1 1v35.5A3.5 3.5 0 0 0 4.6 48H50a1 1 0 1 0 0-2H4.6a1.5 1.5 0 0 1-1.5-1.5V9a1 1 0 0 0-1-1Z",
  clipRule: "evenodd"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M64.4 44.5V10l-7.251-.725a2.5 2.5 0 0 0-2.75 2.487L54.4 34.5a2.5 2.5 0 0 1-2.5 2.5H18.978a2.5 2.5 0 0 0-2.478 2.835l.97 7.164L61.9 47a2.5 2.5 0 0 0 2.5-2.5Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M64.4 8a1 1 0 0 1 1 1v35.5a3.5 3.5 0 0 1-3.5 3.5H16.5a1 1 0 1 1 0-2h45.4a1.5 1.5 0 0 0 1.5-1.5V9a1 1 0 0 1 1-1Z",
  clipRule: "evenodd"
})));
SvgRectangle64DError.viewBox = '0 0 66 48';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle64DError);
export default ForwardRef;